module.exports = __webpack_public_path__ + "static/media/500-internal-server-error.92918293.png";